import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { DialogHost } from '@/components/feedback/dialog';
import { useToast } from '@/components/feedback/toast';
import { routes } from '@/config/routes';
import { AUTH_ERROR_CODES, AUTH_ERROR_COPY } from '@/features/auth';
import { onForceLogout } from '@/lib/api/force-logout';
import { useAuth } from '@/providers/auth-provider';

import { PageContainer } from '../page-container';
import { TopNav } from '../top-nav';

import styles from './app-shell.module.scss';

export function AppShell() {
  const { clearSession } = useAuth();
  const navigate = useNavigate();
  const toast = useToast();

  // US-112329: an account deactivated mid-session force-clears the token (client.ts's response
  // interceptor) and emits this — no separate logout call needed, the session is already dead
  // server-side.
  useEffect(
    () =>
      onForceLogout(() => {
        clearSession();
        navigate(routes.login);
        toast.error({ title: AUTH_ERROR_COPY[AUTH_ERROR_CODES.ACCOUNT_DEACTIVATED] });
      }),
    [clearSession, navigate, toast],
  );

  return (
    <DialogHost>
      <div className={styles.shell}>
        <TopNav />
        <main className={styles.content}>
          <PageContainer>
            <Outlet />
          </PageContainer>
        </main>
      </div>
    </DialogHost>
  );
}
